import styled from "@emotion/styled"
import { PText } from "@porsche-design-system/components-react"
import {
	colorContrastLow,
	colorContrastLower,
	colorSuccess,
	spacingStaticXs,
} from "@porsche-design-system/components-react/emotion"
import { FormattedMessage } from "react-intl"
import { newsListMessages as messages } from "./newsList.messages"

interface NewsReviewProgressProps {
	reviewed: number
	total: number
}

export const NewsReviewProgress = ({ reviewed, total }: NewsReviewProgressProps) => (
	<ProgressLabel>
		<Progress max={total} value={reviewed} />
		<PText size="2xs" color="contrast-medium">
			<FormattedMessage {...messages.reviewProgress} values={{ reviewed, total }} />
		</PText>
	</ProgressLabel>
)

const ProgressLabel = styled.label`
	display: block;
	min-width: 8rem;
`

const Progress = styled.progress`
	display: block;
	width: 100%;
	height: 0.25rem;
	margin-block-end: ${spacingStaticXs};
	border: 0;
	border-radius: calc(infinity * 1px);
	background: ${colorContrastLow};
	appearance: none;
	overflow: hidden;

	&::-webkit-progress-bar {
		background: ${colorContrastLower};
	}

	&::-webkit-progress-value {
		background: ${colorSuccess};
		border-radius: calc(infinity * 1px);
	}

	&::-moz-progress-bar {
		background: ${colorSuccess};
		border-radius: calc(infinity * 1px);
	}

	@media (forced-colors: active) {
		&::-webkit-progress-bar {
			background: ButtonFace;
		}

		&::-webkit-progress-value {
			background: Highlight;
		}

		&::-moz-progress-bar {
			background: Highlight;
		}
	}
`
